import { useCallback, useLayoutEffect, useRef } from 'react'

import { Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import { Nav, Navbar } from 'react-bootstrap'

type NavItemType = {
  id: number
  label: string
  url: string
}

const initNavItems: NavItemType[] = [
  {
    id: 1,
    label: 'Inicio',
    url: '/home',
  },
  {
    id: 2,
    label: 'Proveedores',
    url: '/home/searchpage', // will take us to search page with no filters applied
  },
]

const EcommerceNavbar = () => {
  const { pathname } = useLocation()

  const containerRef = useRef<HTMLDivElement | null>(null)
  const otherElsRef = useRef<HTMLDivElement | null>(null)
  const moreBtnRef = useRef<HTMLDivElement | null>(null)
  const navItemsRef = useRef<(HTMLDivElement | null)[]>([])
  const dropdownItemsRef = useRef<(HTMLAnchorElement | null)[]>([])

  const updateItems = useCallback(() => {
    const otherElsWidth = otherElsRef.current?.clientWidth || 0
    const containerWidth = containerRef.current?.clientWidth || 0
    const moreBtnWidth = moreBtnRef.current?.clientWidth || 0

    let totalItemsWidth = 0
    if (moreBtnRef.current) {
      moreBtnRef.current.style.display = 'none'
    }
    navItemsRef.current.forEach((item, index) => {
      const dropdownItem = dropdownItemsRef.current[index]
      if (item && dropdownItem && moreBtnRef.current) {
        totalItemsWidth = totalItemsWidth + (item.clientWidth || 0) + 32
        if (otherElsWidth + totalItemsWidth + moreBtnWidth + 50 > containerWidth) {
          item.style.display = 'none'
          dropdownItem.style.display = 'block'
          moreBtnRef.current.style.display = 'block'
        } else {
          item.style.display = 'block'
          dropdownItem.style.display = 'none'
        }
      }
    })
  }, [])

  useLayoutEffect(() => {
    updateItems()
  }, [])

  useLayoutEffect(() => {
    window.addEventListener('resize', updateItems)
    return () => {
      window.removeEventListener('resize', updateItems)
    }
  }, [updateItems])

  return (
    <Navbar className="ecommerce-navbar bg-white justify-content-between p-2">
      <div
        className="container-small d-flex flex-between-center flex-nowrap w-100"
        ref={containerRef}
      >
        {/* <Dropdown ref={otherElsRef}>
          <Dropdown.Toggle
            variant=""
            className="text-900 ps-0 pe-5 text-nowrap dropdown-toggle dropdown-caret-none"
          >
            <FontAwesomeIcon icon={faBars} className="me-2" />
            Category
          </Dropdown.Toggle>

          <Dropdown.Menu className="border py-0 category-dropdown-menu ms-2">
            <Card className="border-0">
              <Scrollbar autoHeight autoHeightMax={657}>
              <Card.Body className="p-6 pb-3">
                Category Dropdown content, still need to implement, **talk to EMI**
                <Row className="gx-7 gy-5 mb-5">
                  {categories.map((category) => (
                    <Col xs={12} sm={6} md={4} key={category.title}>
                      <div className="d-flex align-items-center mb-3">
                        <FeatherIcon
                          icon={category.icon}
                          className="text-primary me-2"
                          style={{ strokeWidth: 3 }}
                          size={16}
                        />
                        <h6 className="text-1000 mb-0 text-nowrap">
                          {category.title}
                        </h6>
                      </div>
                      <div className="ms-n2">
                        {category.sections.map((section) => (
                          <Link
                            key={section.label}
                            to={section.url}
                            className="text-black d-block mb-1 text-decoration-none hover-bg-100 px-2 py-1 rounded-2"
                          >
                            {section.label}
                          </Link>
                        ))}
                      </div>
                    </Col>
                  ))}
                </Row>
                <div className="text-center border-top pt-3">
                  <Link className="fw-bold" to="#!">
                    See all Categories
                    <FontAwesomeIcon icon={faAngleRight} className="ms-1" />
                  </Link>
                </div>
              </Card.Body>
              </Scrollbar> still need to implement 
            </Card>
          </Dropdown.Menu>
        </Dropdown> */}

        <Nav
          as="ul"
          className="justify-content-center align-items-center flex-grow-1 gap-5"
          // **we need to move slightly to left to be centered under search bar above it**
        >
          {initNavItems.map((item, index) => (
            <Nav.Item
              className="gap-3"
              key={item.id}
              ref={(el) => (navItemsRef.current[index] = el)}
            >
              <Nav.Link
                as={Link}
                to={item.url}
                className={classNames({
                  active: pathname === item.url,
                })}
              >
                {item.label}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        {/* <Dropdown align="end" as={Nav.Item} ref={moreBtnRef}>
          <Dropdown.Toggle
            variant=""
            className="fw-bold nav-link dropdown-caret-none"
          >
            More
            <FontAwesomeIcon icon={faAngleDown} className="ms-2" />
          </Dropdown.Toggle>

          <Dropdown.Menu align="end" renderOnMount>
            {initNavItems.map((item, index) => (
              <Dropdown.Item
                key={item.id}
                as={Link}
                to={item.url}
                ref={(el) => (dropdownItemsRef.current[index] = el)}
              >
                {item.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown> */}
      </div>
    </Navbar>
  )
}

export default EcommerceNavbar
